import type React from 'react';
import Translation from '../../../../../general/Translation/Translation';
import Picture from '../../../../../general/Picture/Picture';
import Source from '../../../../../general/Picture/Source';

const Hero: React.FC = () => (
    <div className="page-header">
        <div className="wrapper">
            <div className="hero hero--static is-placed-center has-overlay">
                <div className="hero__content">
                    <h2>
                        <Translation pageString='winkelmand_teksten' stringId='need_help' />
                    </h2>
                </div>
                <div className="hero__overlay"></div>
                <div className="hero__image">
                    <Picture alt='Customer Service' imageUrl='https://static.yoursurprise.com/resourcebase/files/542/1268099.jpg' lazyLoad={false}>
                        <Source framing={false} ratio='2:1' imageWidth={1360} imageHeight={320} minScreenWidth={1360} />
                        <Source framing={false} ratio='2:1' imageWidth={992} imageHeight={320} minScreenWidth={992} />
                        <Source framing={false} ratio='2:1' imageWidth={768} imageHeight={320} minScreenWidth={768} />
                        <Source framing={false} ratio='2:1' imageWidth={768} imageHeight={240} minScreenWidth={576} />
                        <Source framing='crop' imageWidth={390} imageHeight={240} ratio='2:1,offset-x20,offset-y0'/>
                    </Picture>
                </div>
            </div>
        </div>
    </div>
);

export default Hero;
